<template>
  <v-row align="center" justify="center" id="posts">
    <div
      :v-infinite-scroll="loadMore"
      infinite-scroll-disabled="busy"
      infinite-scroll-distance="limit"
    >
      <v-col
        v-for="project in projects"
        v-bind:key="project.title"
        data-aos="fade-up"
        data-aos-duration="3000"
        data-aos-offset="100"
        data-aos-easing="ease-out-back"
      >
        <v-skeleton-loader
          class="mx-auto"
          :loading="posts.length !== limit"
          v-bind:width="getWidth()/1.5"
          type="card-heading, text, image, paragraph, button"
        >
          <v-card v-bind:max-width="getWidth()/1.5" class="mx-auto">
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title class="headline">{{ project.title }}</v-list-item-title>
                <v-list-item-subtitle>{{ project.sub_title}}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>

            <v-img
              :src="project.img"
              :contain="project.img === require('@/assets/jenkins.png')"
              lazy-src="https://picsum.photos/id/11/100/60"
              v-bind:max-height="getHeight()/2"
            >
              <template v-slot:placeholder>
                <v-row class="fill-height ma-0" align="center" justify="center">
                  <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                </v-row>
              </template>
            </v-img>

            <v-card-text>{{ project.description }}</v-card-text>

            <v-card-actions>
              <v-btn text color="deep-purple accent-4" :href="project.url" target="_blank">Read More</v-btn>
              <v-spacer></v-spacer>
              <v-btn icon>
                <v-icon>mdi-star</v-icon>
                <span class="subheading mr-2">{{ project.star }}</span>
              </v-btn>
              <span class="mr-1">·</span>
              <v-btn icon>
                <v-icon>mdi-source-fork</v-icon>
                <span class="subheading mr-2">{{ project.fork }}</span>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-skeleton-loader>
      </v-col>
      <br />
    </div>
  </v-row>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      posts: [],
      limit: 5,
      busy: false,
      projects: [
        {
          title: "DNS Amplification Lab",
          sub_title: "Using Scapy for DNS amplification",
          description:
            "DNS (Domain Name System) is the Internet’s phone book; \
                  it translates hostnames to IP addresses (or IP addresses to hostnames). \
                  This translation is through DNS resolution, which happens behind the scene...",
          img: require("@/assets/explanation.png"),
          star: 5,
          fork: 1,
          url: "https://github.com/Avielyo10/DNS-Amplification-Lab"
        },
        {
          title: "Crypto lab",
          sub_title: "SEED Labs - RSA Public-Key Encryption and Signature Lab",
          description: "",
          img: require("@/assets/RSA.png"),
          star: 1,
          fork: 1,
          url: "https://github.com/Avielyo10/crypto-lab"
        },
        {
          title: "Cachet Gating Plugin",
          sub_title:
            "A gating mechanism based on the availability of resources",
          description: "",
          img: require("@/assets/jenkins.png"),
          star: 1,
          fork: 4,
          url: "https://github.com/jenkinsci/cachet-gating-plugin"
        },
        {
          title: "Jenkins LinchPin Plugin",
          sub_title: "This plugin integrate LinchPin & Cinch with Jenkins",
          description:
            "LinchPin is a simple and flexible hybrid cloud orchestration tool. \
            Its intended purpose is managing cloud resources across multiple \
            infrastructures. These resources can be provisioned, decommissioned, \
            and configured all using declarative data and a simple command-line interface...",
          img: require("@/assets/jenkins.png"),
          star: 0,
          fork: 1,
          url: "https://github.com/Avielyo10/linchpin-plugin"
        }
      ]
    };
  },
  methods: {
    loadMore() {
      this.busy = true;
      axios.get("https://jsonplaceholder.typicode.com/posts").then(response => {
        const append = response.data.slice(
          this.posts.length,
          this.posts.length + this.limit
        );
        this.posts = this.posts.concat(append);
        this.busy = false;
      });
    },
    getHeight() {
      return window.innerHeight;
    },
    getWidth() {
      return window.innerWidth;
    }
  },
  created() {
    this.loadMore();
  },
  name: "Posts"
};
</script>